import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import React from 'react'
import { ContactNoteRemovalButton } from '../../components/buttons/ContactNoteButtons';
import ContactNoteDialog from '../../dialogs/notes/ContactNoteDialog';
import { ContactNote } from '@agtech/data/contacts/notes/ContactNoteData';

export type ContactNoteActionMenuProps = {
    contactId: number,
    note: ContactNote
}

const ContactNoteActionMenu = (props: ContactNoteActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Note">
                <ContactNoteDialog.Button contactId={props.contactId} note={props.note} />
                <ContactNoteRemovalButton note={props.note} />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
};

export default ContactNoteActionMenu;